import { render, staticRenderFns } from "./pedidoexport.vue?vue&type=template&id=3795eebb&scoped=true&"
import script from "./pedidoexport.vue?vue&type=script&lang=js&"
export * from "./pedidoexport.vue?vue&type=script&lang=js&"
import style0 from "./pedidoexport.vue?vue&type=style&index=0&id=3795eebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3795eebb",
  null
  
)

export default component.exports